/**
 * @desc 盘亏打印批次号
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/printBatchNo/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
